import React from 'react';
import { useEffect, useState } from 'react';

export const FeedbacksList = ({ feedback: { name, feedback, email } }) => {
  const [cutShort, setCutShort] = useState(false);
  const [font, setFont] = useState('plus');

  useEffect(() => {
    if (feedback.length >= 110) {
      setCutShort(true);
    }
  }, [feedback]);

  const toggleAccordion = (e) => {
    const feedbackElem = e.target.parentElement.parentElement;
    const feedbackMsg = feedbackElem.querySelector('.feedback-msg');

    if (font === 'minus') {
      setFont('plus');
      feedbackMsg.style.maxHeight = `60px`;
    } else {
      setFont('minus');
      feedbackMsg.style.maxHeight = `${feedbackMsg.scrollHeight}px`;
    }
  };

  return (
    <div>
      <div className='user-info'>
        <div className='avatar'>
          <i className='fas fa-user'></i>
        </div>
        <p>{name}</p>
        {cutShort && (
          <i className={`fas fa-${font}`} onClick={toggleAccordion}></i>
        )}
      </div>
      <p className='feedback-msg'>{feedback}</p>
      <p className='feedback-footer'>@{email}</p>
    </div>
  );
};
